var map = {
	"./reviews0.json": [
		20,
		20
	],
	"./reviews1.json": [
		533,
		533
	],
	"./reviews10.json": [
		379,
		379
	],
	"./reviews11.json": [
		435,
		435
	],
	"./reviews12.json": [
		268,
		268
	],
	"./reviews13.json": [
		28,
		28
	],
	"./reviews14.json": [
		740,
		740
	],
	"./reviews15.json": [
		775,
		775
	],
	"./reviews16.json": [
		765,
		765
	],
	"./reviews17.json": [
		358,
		358
	],
	"./reviews18.json": [
		778,
		778
	],
	"./reviews19.json": [
		731,
		731
	],
	"./reviews3.json": [
		460,
		460
	],
	"./reviews4.json": [
		638,
		638
	],
	"./reviews5.json": [
		981,
		981
	],
	"./reviews6.json": [
		763,
		763
	],
	"./reviews7.json": [
		871,
		871
	],
	"./reviews8.json": [
		704,
		704
	],
	"./reviews9.json": [
		914,
		914
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 92;
module.exports = webpackAsyncContext;